import { render, staticRenderFns } from "./AuditingPrescription.vue?vue&type=template&id=c5f5b4d0&scoped=true"
import script from "./AuditingPrescription.vue?vue&type=script&lang=js"
export * from "./AuditingPrescription.vue?vue&type=script&lang=js"
import style0 from "./AuditingPrescription.vue?vue&type=style&index=0&id=c5f5b4d0&prod&scoped=true&lang=css"
import style1 from "./AuditingPrescription.vue?vue&type=style&index=1&id=c5f5b4d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f5b4d0",
  null
  
)

export default component.exports